/**
 * API配置文件
 * 根据环境动态配置API地址
 */

// 环境检测
const isDevelopment = () => {
  // 只有在本地开发环境（localhost或127.0.0.1）时才认为是开发环境
  return typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
}

const isProduction = () => {
  // 除了localhost和127.0.0.1之外的所有环境都认为是生产环境
  return typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1'
}

// 获取API基础URL
export const getApiBaseURL = () => {
  // 优先使用环境变量（构建时注入）
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL
  }
  
  // 开发环境：使用localhost
  if (isDevelopment()) {
    return 'http://localhost:8080/api'
  }
  
  // 生产环境：根据当前访问的服务器确定API地址
  if (isProduction()) {
    // 检查是否在容器内部（通过检查hostname）
    if (typeof window !== 'undefined' && window.location.hostname === 'backend') {
      // 在容器内部，直接调用backend服务
      return 'http://backend:8080/api'
    } else {
      // 在浏览器中访问生产环境，使用当前域名但端口改为8080
      const protocol = window.location.protocol
      const hostname = window.location.hostname
      // 如果是通过IP地址访问（如172.23.106.192:5180），API端口应该是8080
      if (hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) {
        return `${protocol}//${hostname}:8080/api`
      } else {
        // 域名访问，使用当前域名
        const port = window.location.port ? `:${window.location.port}` : ''
        return `${protocol}//${hostname}${port}/api`
      }
    }
  }
  
  // 默认：使用localhost
  return 'http://localhost:8080/api'
}

// 获取WebSocket URL
export const getWebSocketURL = () => {
  if (isDevelopment()) {
    return 'ws://localhost:8080/ws'
  }
  
  if (isProduction()) {
    // 检查是否在容器内部
    if (typeof window !== 'undefined' && window.location.hostname === 'backend') {
      return 'ws://backend:8080/ws'
    } else {
      // 在浏览器中，使用当前域名
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
      const hostname = window.location.hostname
      const port = window.location.port ? `:${window.location.port}` : ''
      return `${protocol}//${hostname}${port}/ws`
    }
  }
  
  return import.meta.env.VITE_WS_URL || 'ws://localhost:8080/ws'
}

// 环境信息
export const getEnvironmentInfo = () => {
  return {
    isDevelopment: isDevelopment(),
    isProduction: isProduction(),
    apiBaseURL: getApiBaseURL(),
    wsURL: getWebSocketURL(),
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'unknown',
    protocol: typeof window !== 'undefined' ? window.location.protocol : 'unknown'
  }
} 